import React from 'react';
import { Section } from './ui/Section';
export function ProblemSection() {
  return <Section className="bg-navy-800" dark={true} data-id="element-175">
      <div className="space-y-12 text-center md:text-left" data-id="element-176">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-177">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight" data-id="element-178">
            Esto es para la mujer que puede con todo…{' '}
            <span className="text-gold-400 italic" data-id="element-179">
              excepto apagar su cerebro.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-16" data-id="element-180">
          <div className="space-y-6 text-lg text-cream-100/80 leading-relaxed" data-id="element-181">
            <p data-id="element-182">Si tienes más de 40, probablemente te han dicho lo mismo:</p>
            <ul className="space-y-3 pl-4 border-l-2 border-gold-500/30" data-id="element-183">
              <li data-id="element-184">"Solo medita."</li>
              <li data-id="element-185">"Prueba la melatonina."</li>
              <li data-id="element-186">"Deja la cafeína."</li>
              <li data-id="element-187">"Aleja el teléfono."</li>
            </ul>
            <p data-id="element-188">
              Y quizás has probado algo de eso. Pero esto es lo que nadie dice
              en voz alta:
            </p>
            <p className="font-serif text-2xl text-gold-400 italic" data-id="element-189">
              La mayoría de los consejos para dormir están hechos para personas
              que no viven en tu cerebro.
            </p>
          </div>

          <div className="bg-navy-900 p-8 md:p-10 rounded-2xl border border-navy-700 shadow-xl" data-id="element-190">
            <h3 className="text-2xl font-serif mb-6 text-cream-50" data-id="element-191">
              La Realidad
            </h3>
            <div className="space-y-4 text-cream-100/70" data-id="element-192">
              <p data-id="element-193">Repites conversaciones en tu mente.</p>
              <p data-id="element-194">Repasas la lista de pendientes de mañana.</p>
              <p data-id="element-195">Resuelves problemas que ni siquiera existen todavía.</p>
              <p data-id="element-196">
                Y si logras dormirte, te despiertas entre las 2 y las
                4am—alerta, tensa, y de alguna manera convencida de que pensar
                más es la única forma de proteger el mañana.
              </p>
              <div className="pt-6 border-t border-navy-700 mt-6" data-id="element-197">
                <p className="text-lg font-medium text-gold-400" data-id="element-198">
                  No necesitas otro consejo. Necesitas una secuencia de apagado
                  repetible.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}